import { Menu, MenuItem, Tooltip } from "@mui/material";
import React from "react";

type RowActionItem = {
  key: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  disabledReason?: string;
};

type RowActionsMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onEdit: () => void;
  disableEdit?: boolean;
  disableEditReason?: string;
  editText?: string;
  onDelete?: () => void;
  disableDelete?: boolean;
  disableDeleteReason?: string;
  deleteText?: string;
  extraActions?: RowActionItem[];
};

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onEdit,
  disableEdit,
  disableEditReason,
  editText = "Edit",
  onDelete,
  disableDelete,
  disableDeleteReason,
  deleteText = "Delete",
  extraActions = [],
}) => {
  const editItem = (
    <MenuItem
      disabled={!!disableEdit}
      onClick={() => {
        onEdit();
        onClose();
      }}
    >
      {editText}
    </MenuItem>
  );

  const deleteItem = (
    <MenuItem
      disabled={Boolean(disableDelete)}
      onClick={() => {
        onDelete?.();
        onClose();
      }}
    >
      {deleteText}
    </MenuItem>
  );

  const renderMenuItem = (item: RowActionItem) => {
    const menuItem = (
      <MenuItem
        key={item.key}
        disabled={Boolean(item.disabled)}
        onClick={() => {
          item.onClick();
          onClose();
        }}
      >
        {item.label}
      </MenuItem>
    );

    if (!item.disabled || !item.disabledReason) {
      return menuItem;
    }

    return (
      <Tooltip key={item.key} title={item.disabledReason} placement="left" arrow>
        <span>{menuItem}</span>
      </Tooltip>
    );
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      {disableEdit && disableEditReason ? (
        <Tooltip title={disableEditReason} placement="left" arrow>
          <span>{editItem}</span>
        </Tooltip>
      ) : (
        editItem
      )}
      {extraActions.map(renderMenuItem)}
      {onDelete && (
        disableDelete && disableDeleteReason ? (
          <Tooltip title={disableDeleteReason} placement="left" arrow>
            <span>{deleteItem}</span>
          </Tooltip>
        ) : (
          deleteItem
        )
      )}
    </Menu>
  );
};

export default RowActionsMenu;
